import React, { useRef, useEffect, useState } from 'react';

const AutoPlayAudioPlayer = ({ fileName }) => {
    const [filePath ,setFilePath] = useState("");
    const audioRef: any = useRef(null);
    const getImageFilePath = async () => {
        try {
          const response = await fetch(`assets/audioSpeeches/${fileName}`);
          if (response.ok) {
            const filePath = response.url;
            setFilePath(filePath);
          } else {
            console.error("Failed to fetch the image");
          }
        } catch (error) {
          console.error("Error fetching the image:", error);
        }
      };
    useEffect(() => {
        {
            const playAudio = async () => {
                try {
                    await audioRef.current.play();
                } catch (error) {
                    console.error("Error trying to play audio:", error);
                }
            }
            getImageFilePath();
            playAudio();
        }
    }, [fileName]);

    // const playAudioWithDelay = (delay) => {
    //     if (audioRef.current) {
    //         setTimeout(() => {
    //             audioRef.current.play();
    //         }, delay);
    //     }
    // };
    return (
        <audio
            ref={audioRef}
            src={filePath + ".mp3"}
            autoPlay
            // onEnded={() => playAudioWithDelay(6000)}
        />
    );
};

export default AutoPlayAudioPlayer;